import script from "./GroupEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupEmail.vue?vue&type=script&setup=true&lang=js"

import "./GroupEmail.vue?vue&type=style&index=0&id=28c2859d&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c2859d"]])

export default __exports__